import * as React from "react"
import type { SVGProps } from "react"
const SvgChatMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m6 18.29-2.3 2.3a.9.9 0 0 1-1.09.2.94.94 0 0 1-.61-.93V4.3q0-.83.59-1.42A2 2 0 0 1 4 2.3h16q.83 0 1.41.58.6.6.59 1.42v12q0 .83-.59 1.4a2 2 0 0 1-1.41.6zm-.85-2H20v-12H4V17.4z" />
  </svg>
)
export default SvgChatMessage
